import Icon from 'veui/components/Icon'

Icon.register({
  'doc-ppt': {
    paths: [
      {
        d: 'M672 254.29c-.49-4.42-1-10.93-7.37-18.78l-160-192c-5.31-6.18-14-11.65-24.58-11.51H128a32 32 0 00-32 32v640a32 32 0 0032 32h512a32 32 0 0032-32V254.29zm-160-101.9L571.68 224H512zM608 672H160V96h288v160a32 32 0 0032 32h128zM454.74 346.13Q443.4 335.87 424.5 331t-47-4.86h-85.3V576h54.72v-77h30.6q26.28 0 45-4.5t30.6-14.94q11.88-10.47 17.28-27.23t5.4-41.22q0-22.68-4.86-38.7a56.9 56.9 0 00-16.2-26.28zm-37.26 86.76A27.45 27.45 0 01409 446a33.89 33.89 0 01-15.3 7 115 115 0 01-23.4 2h-23.4v-85.65h23.4a106.86 106.86 0 0123.22 2.16 35.8 35.8 0 0115.48 7.2 27.57 27.57 0 018.48 13.29 70 70 0 012.52 20.19q0 12.62-2.52 20.7z'
      }
    ],
    width: '768',
    height: '768'
  }
})
